import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cbcc7e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "content__title" }, "Юридические документы", -1))
const _hoisted_3 = { class: "juristicDocuments" }
const _hoisted_4 = ["href"]


export default /*#__PURE__*/_defineComponent({
  __name: 'JuristicDocuments',
  setup(__props) {

const documents = [
  {
    title: 'Политика конфиденциальности',
    document: '',
  },
  {
    title: 'Согласие на обработку персональных данных',
    document: '',
  },
  {
    title: 'Согласие на получение рекламных рассылок',
    document: '',
  },
  {
    title: 'Рекомендация технологии',
    document: '',
  },
  {
    title: 'Лицензионное соглашение',
    document: '',
  },
  {
    title: 'Соглашение использования сайта banki.shop',
    document: '',
  },
  {
    title: 'Реквизиты',
    document: '',
  },
];

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(documents, (doc, i) => {
        return _createVNode(_component_base_card, {
          key: i,
          class: "juristicDocuments__docItem scale"
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", {
              href: doc.document,
              class: "items-in-column align-center",
              download: ""
            }, [
              _createVNode(_component_base_icon, {
                "font-size": "50",
                name: "description"
              }),
              _createElementVNode("span", null, _toDisplayString(doc.title), 1)
            ], 8, _hoisted_4)
          ]),
          _: 2
        }, 1024)
      }), 64))
    ])
  ]))
}
}

})